import { json } from 'd3';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['pagination', 'entries', 'spinner'];
  pagination_rendered = []

  initialize() {
    let options = {
      rootMargin: '200px',
    };

    this.intersectionObserver = new IntersectionObserver(entries => this.processIntersectionEntries(entries), options);

    $(this.spinnerTarget).hide();
  }

  connect() {
    document.querySelectorAll('#pagination').forEach(component => {
      this.intersectionObserver.observe(component)
    });
  }

  disconnect() {
    document.querySelectorAll('#pagination').forEach(component => {
      this.intersectionObserver.unobserve(component)
    });
  }

  processIntersectionEntries(entries) {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        this.loadMore(entry.target);
      }
    });
  }

  loadMore() {
    let next_page = this.paginationTarget.querySelector("a[rel='next']");
    if(next_page == null) return;
    let url = next_page.href;
    $(this.spinnerTarget).show();
    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: (response) => {
        this.entriesTarget.insertAdjacentHTML('beforeend', response.entries);
        this.paginationTarget.innerHTML = response.pagination;
        $(this.spinnerTarget).hide();
      }
    });
  }

}